import React, { useState, useEffect } from 'react';
import Navigation from '../Components/Navigation';
import '../Assets/Styles/EditeProfle_page.css';

const EditProfile = () => {
  const [profileData, setProfileData] = useState({
    contact: '+91 1234567890',
    officeAddress: '123 Business Street, Financial District, Mumbai, Maharashtra - 400001',
    sebiRegistrationNo: 'SEBI REG. NO. INH000000000',
    email: 'contact@trillionstock.com',
    instagram: 'https://instagram.com/trillionstock',
    facebook: 'https://facebook.com/trillionstock',
    youtube: 'https://youtube.com/trillionstock',
    bankName: 'State Bank of India',
    accountNumber: '12345678901234',
    ifscCode: 'SBIN0001234',
    branchName: 'Mumbai Main Branch',
    accountName: 'Trillionstock Research',
    accountType: 'Current',
    upiId1: 'trillionstock@upi',
    upiId2: 'trillionstock2@upi'
  });

  const [activeSection, setActiveSection] = useState('contact');

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 100; // Offset for better accuracy

      // Get all section elements
      const sectionElements = document.querySelectorAll('.form-section');
      
      // Find the section that's currently in view
      let currentSection = 'contact';
      sectionElements.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        
        if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
          currentSection = section.id;
        }
      });

      setActiveSection(currentSection);
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);
    
    // Initial check
    handleScroll();

    // Cleanup
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfileData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Log the form data in a structured way
    console.log('=== Profile Data ===');
    console.log('Contact Information:');
    console.log('Contact:', profileData.contact);
    console.log('Email:', profileData.email);
    
    console.log('\nCompany Details:');
    console.log('Office Address:', profileData.officeAddress);
    console.log('SEBI Registration No:', profileData.sebiRegistrationNo);
    
    console.log('\nBank Details:');
    console.log('Bank Name:', profileData.bankName);
    console.log('Account Number:', profileData.accountNumber);
    console.log('Account Type:', profileData.accountType);
    console.log('IFSC Code:', profileData.ifscCode);
    console.log('Branch Name:', profileData.branchName);
    console.log('Account Name:', profileData.accountName);
    console.log('UPI ID 1:', profileData.upiId1);
    console.log('UPI ID 2:', profileData.upiId2);
    
    console.log('\nSocial Media Links:');
    console.log('Instagram:', profileData.instagram);
    console.log('Facebook:', profileData.facebook);
    console.log('YouTube:', profileData.youtube);
    
    // You can also log the entire object if needed
    console.log('\nComplete Profile Data Object:', profileData);
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="app-container">
      <Navigation />
      <div className="main-content">
        <div className="edit-profile-container">
          <div className="progress-tracker">
            <div className="progress-line"></div>
            <div 
              className={`progress-dot ${activeSection === 'contact' ? 'active' : ''}`} 
              onClick={() => scrollToSection('contact')}
            >
              <span className="dot-tooltip">Contact Information</span>
            </div>
            <div 
              className={`progress-dot ${activeSection === 'company' ? 'active' : ''}`} 
              onClick={() => scrollToSection('company')}
            >
              <span className="dot-tooltip">Company Details</span>
            </div>
            <div 
              className={`progress-dot ${activeSection === 'bank' ? 'active' : ''}`} 
              onClick={() => scrollToSection('bank')}
            >
              <span className="dot-tooltip">Bank Details</span>
            </div>
            <div 
              className={`progress-dot ${activeSection === 'social' ? 'active' : ''}`} 
              onClick={() => scrollToSection('social')}
            >
              <span className="dot-tooltip">Social Media</span>
            </div>
          </div>

          <div className="edit-profile-header">
            <h1>Company Profile Settings</h1>
            <p>Update your company's contact information and registration details</p>
          </div>

          <div className="edit-profile-content">
            <form onSubmit={handleSubmit} className="profile-form">
              <div className="form-section" id="contact">
                <h2>Contact Information</h2>
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="contact">Contact Number</label>
                    <input
                      type="tel"
                      id="contact"
                      name="contact"
                      value={profileData.contact}
                      onChange={handleInputChange}
                      placeholder="Enter contact number"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email Address</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={profileData.email}
                      onChange={handleInputChange}
                      placeholder="Enter email address"
                    />
                  </div>
                </div>
              </div>

              <div className="form-section" id="company">
                <h2>Company Details</h2>
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="officeAddress">Office Address</label>
                    <textarea
                      id="officeAddress"
                      name="officeAddress"
                      value={profileData.officeAddress}
                      onChange={handleInputChange}
                      placeholder="Enter complete office address"
                      rows="3"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="sebiRegistrationNo">SEBI Registration No.</label>
                    <input
                      type="text"
                      id="sebiRegistrationNo"
                      name="sebiRegistrationNo"
                      value={profileData.sebiRegistrationNo}
                      onChange={handleInputChange}
                      placeholder="Enter SEBI registration number"
                    />
                  </div>
                </div>
              </div>

              <div className="form-section" id="bank">
                <h2>Bank Details</h2>
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="bankName">Bank Name</label>
                    <input
                      type="text"
                      id="bankName"
                      name="bankName"
                      value={profileData.bankName}
                      onChange={handleInputChange}
                      placeholder="Enter bank name"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="accountNumber">Account Number</label>
                    <input
                      type="text"
                      id="accountNumber"
                      name="accountNumber"
                      value={profileData.accountNumber}
                      onChange={handleInputChange}
                      placeholder="Enter account number"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="accountType">Account Type</label>
                    <select
                      id="accountType"
                      name="accountType"
                      value={profileData.accountType}
                      onChange={handleInputChange}
                      className="form-select"
                    >
                      <option value="Current">Current</option>
                      <option value="Saving">Saving</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="ifscCode">IFSC Code</label>
                    <input
                      type="text"
                      id="ifscCode"
                      name="ifscCode"
                      value={profileData.ifscCode}
                      onChange={handleInputChange}
                      placeholder="Enter IFSC code"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="branchName">Branch Name</label>
                    <input
                      type="text"
                      id="branchName"
                      name="branchName"
                      value={profileData.branchName}
                      onChange={handleInputChange}
                      placeholder="Enter branch name"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="accountName">Account Name</label>
                    <input
                      type="text"
                      id="accountName"
                      name="accountName"
                      value={profileData.accountName}
                      onChange={handleInputChange}
                      placeholder="Enter account holder name"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="upiId1">UPI ID 1</label>
                    <input
                      type="text"
                      id="upiId1"
                      name="upiId1"
                      value={profileData.upiId1}
                      onChange={handleInputChange}
                      placeholder="Enter first UPI ID"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="upiId2">UPI ID 2</label>
                    <input
                      type="text"
                      id="upiId2"
                      name="upiId2"
                      value={profileData.upiId2}
                      onChange={handleInputChange}
                      placeholder="Enter second UPI ID"
                    />
                  </div>
                </div>
              </div>

              <div className="form-section" id="social">
                <h2>Social Media Links</h2>
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="instagram">Instagram URL</label>
                    <input
                      type="url"
                      id="instagram"
                      name="instagram"
                      value={profileData.instagram}
                      onChange={handleInputChange}
                      placeholder="https://instagram.com/your-company"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="facebook">Facebook URL</label>
                    <input
                      type="url"
                      id="facebook"
                      name="facebook"
                      value={profileData.facebook}
                      onChange={handleInputChange}
                      placeholder="https://facebook.com/your-company"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="youtube">YouTube URL</label>
                    <input
                      type="url"
                      id="youtube"
                      name="youtube"
                      value={profileData.youtube}
                      onChange={handleInputChange}
                      placeholder="https://youtube.com/your-company"
                    />
                  </div>
                </div>
              </div>

              <div className="form-actions">
                <button type="button" className="cancel-button">Cancel</button>
                <button type="submit" className="save-button">Save Changes</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
